<template>
  <InnerCardInfo
    v-if="taxCardData"
    :label="localStorage.translations.pages['setting-personal_area'].sections['nalogovaya-karta']"
    :data="[
      {
        name: localStorage.translations.pages['setting-personal_area'].labels[
          'verhniy-uroven-zarobotnoy-platy'
        ],
        value: upper_wage_level ? $formatCurrency(upper_wage_level) + ' €' : '-',
      },
      {
        name: localStorage.translations.pages['setting-personal_area'].labels['nizhniy-protsent'],
        value: lower_percentage ? lower_percentage + ' %' : '-',
      },
      {
        name: localStorage.translations.pages['setting-personal_area'].labels['verhniy-protsent'],
        value: top_percentage ? top_percentage + ' %' : '-',
      },
    ]"
    :images="taxCardData.image"
    need-image-domain
    ref="inner"
    :editReady="editReady"
  >
    <template slot="edit_block">
      <slot />
    </template>
  </InnerCardInfo>
</template>

<script>
import InnerCardInfo from './InnerCardInfo'
export default {
  name: 'TaxCardPdf',
  props: { tax_card: Object, editReady: Boolean },
  components: { InnerCardInfo },
  data: () => ({
    taxCardData: null,
    upper_wage_level: null,
    lower_percentage: null,
    top_percentage: null,
    images: null,
  }),
  watch: {
    tax_card() {
      this.getTaxCard()
    },
  },
  mounted() {
    this.getTaxCard()
  },
  methods: {
    getTaxCard() {
      if (this.tax_card) {
        this.taxCardData = JSON.parse(this.tax_card.data)
        this.upper_wage_level = this.taxCardData.upper_wage_level
        this.lower_percentage = this.taxCardData.lower_percentage
        this.top_percentage = this.taxCardData.top_percentage
        this.images = this.taxCardData.image
      }
    },
  },
}
</script>
